module.exports = __webpack_public_path__ + "static/aa-logo-d8fa967cc4d06f95b2a4e47b73a074e5.jpeg";